import type { ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';
import { STATUS_COLOR_CLASS } from '@/styles/statusColors';

interface WarningNoticeProps {
  children: ReactNode;
}

export function WarningNotice({ children }: WarningNoticeProps) {
  return (
    <p
      role="note"
      className={cn(
        'flex items-start gap-2.5 rounded-xl px-3.5 py-3 text-sm font-medium ring-1 ring-warning-foreground/20',
        STATUS_COLOR_CLASS.warning,
      )}
    >
      <TriangleAlert className="mt-0.5 size-4 shrink-0" aria-hidden />
      <span>{children}</span>
    </p>
  );
}
